import { render, staticRenderFns } from "./BaikalAttractions.vue?vue&type=template&id=56be4530"
import script from "./BaikalAttractions.vue?vue&type=script&lang=js"
export * from "./BaikalAttractions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports